import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {ConfirmPopUpComponent} from './confirm-pop-up.component';
import {ConfirmPopUpSkeletonComponent} from './skeleton/confirm-pop-up-skeleton.component';

@NgModule({
    entryComponents: [ConfirmPopUpComponent],
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    exports: [ConfirmPopUpComponent, ConfirmPopUpSkeletonComponent],
    declarations: [ConfirmPopUpComponent, ConfirmPopUpSkeletonComponent]
})
export class ConfirmPopUpModule {
}
